import { RestrictedByTooltip } from "components";
import { PaywallModalTypes } from "components/restrictedByAddOn/paywallModal/types";
import RestrictedByAddOn from "components/restrictedByAddOn/RestrictedByAddOn";
import { RolePermissions } from "enums";
import { useNavigate } from "react-router";
import { Button } from "semantic-ui-react";
import { type ReactElement } from "react";

export const CreateButton = () => {
  const navigate = useNavigate();

  const onClick = () => navigate("create");
  const renderButton = (action: () => void, hasAnyPermission: boolean): ReactElement => (
    <RestrictedByTooltip hasPermission={hasAnyPermission}>
      <Button primary onClick={action} disabled={!hasAnyPermission}>
        Import SCORM Package
      </Button>
    </RestrictedByTooltip>
  );

  return (
    <RestrictedByAddOn
      permissions={[RolePermissions.AssetsManage, RolePermissions.AssetsCreate]}
      addOnPermissions={[RolePermissions.AssetsCreate]}
      modalType={PaywallModalTypes.UpgradeToCreateContent}
      action={onClick}
      renderContent={renderButton}
    />
  );
};
